/**
 * Home collection cards: pick a random in-stock product photo on each visit.
 */
function revealHomeCollectionCovers() {
  document.querySelectorAll('[data-cover-pool]').forEach((root) => {
    const jsonEl = root.querySelector('[data-cover-json]');
    const img = root.querySelector('img.resource-image__image');
    const reveal = () => root.classList.add('is-cover-ready');

    if (!img) {
      reveal();
      return;
    }

    let pool = [];
    try {
      pool = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    } catch (error) {
      pool = [];
    }
    pool = (pool || []).filter((item) => item && item.image);

    if (!pool.length) {
      reveal();
      return;
    }

    const pick = pool[Math.floor(Math.random() * pool.length)];
    img.addEventListener('load', reveal, { once: true });
    img.addEventListener('error', reveal, { once: true });
    const sized = (width) => pick.image.replace(/width=\d+/, 'width=' + width);
    img.src = sized(800);
    img.srcset = sized(800) + ' 800w, ' + sized(1200) + ' 1200w';
    img.sizes = '(min-width: 990px) 25vw, 50vw';
    if (pick.alt) img.alt = pick.alt;
    if (img.complete) reveal();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', revealHomeCollectionCovers, { once: true });
} else {
  revealHomeCollectionCovers();
}
